module.exports = __webpack_public_path__ + "img/6_99.b6c47509.png";